module.exports = __webpack_public_path__ + "img/1L1.62717e2e.png";